import Dexie from 'dexie';

//for api reference visit dexie library https://dexie.org/docs/API-Reference#quick-reference

// Scope database name to ApplicationRoot to isolate multiple deployments
// e.g., /basetest and /production get separate IndexedDB stores
function getDbName() {
    let pathName = (window.location.pathname || '/').replace(/^\/+|\/+$/g, '');
    if (pathName) {
        return `sarasx_${pathName}_app`;
    }
    return 'sarasx_app';
}

const db = new Dexie(getDbName());

db.version(5).stores({
    gn: "key",
    locale: "key",
    tour: "key"
});

export default db;